import Dropdown from "~/components/shared/Dropdown";
import Icon from "~/components/shared/Icon";
import TestPlan from "~/components/analytics/shared/Metadata/TestPlan";
import { TestPlanProps } from "~/components/analytics/shared/type";

type TestPlanDropdownProps = {
  testPlans: TestPlanProps[];
};

const TestPlansDropdown = ({ testPlans }: TestPlanDropdownProps) => (
  <Dropdown className="!overflow-visible">
    <button className="flex items-center gap-1 hover:underline">
      <Icon icon="heroicons/outline/bars-3-bottom-left" style={{ height: 14, width: 14 }} />
      {`Test Plan${testPlans.length > 1 ? "s" : ""}`} ({testPlans.length})
    </button>
    <ul>
      {testPlans.map((testPlan) => (
        <TestPlan
          key={testPlan.id}
          runName={testPlan.runName}
          id={testPlan.id}
          orchestrationLink={testPlan.orchestrationLink}
          partitions={{
            count: testPlan.partitions.count,
            min: testPlan.partitions.min,
            max: testPlan.partitions.max,
          }}
        />
      ))}
    </ul>
  </Dropdown>
);

export default TestPlansDropdown;
